import React from 'react';
import './dm-spinner-button.scss';
import DMButton from '../FormControls/DMButton';
import { CSSTransition } from 'react-transition-group';
import Spinner from '../../common/Spinner/Spinner';

const DMSpinnerButton = (props) => {
    const { className, text, type, disabled, transitionIn, transitionClassName, spinnerClassName, transitionTimeout, withTransition, onClick, ...restProps } = props;

    const getSpinnerClassName = () => {
        return spinnerClassName ? spinnerClassName : {
            border: '2px solid transparent',
            borderTop: '2px solid #ffffff',
            borderLeft: '2px solid #ffffff',
            animation: 'spin 1.2s linear infinite'
        }
    }

    const getTransitionTimeout = () => {
        if (withTransition) {
            return transitionTimeout ? transitionTimeout : 0;
        }

        return 0;
    }

    return (
        <div className='btn-spinner-container transition-delay'>
            <DMButton
                className={className}
                text={text}
                type={type}
                disabled={disabled}
                onClick={onClick}>
                <CSSTransition
                    in={transitionIn}
                    classNames={transitionClassName}
                    timeout={getTransitionTimeout()}
                    unmountOnExit>
                    <div className='spinner-container'>
                        <Spinner style={getSpinnerClassName()} />
                    </div>
                </CSSTransition>
            </DMButton>
        </div>
    );
};

export default DMSpinnerButton;